import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/charts/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/core/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"node_modules/@croco/utils-next-font-pretendard/dist/index.mjs\",\"import\":\"\",\"arguments\":[{\"src\":\"../PretendardVariable.woff2\",\"display\":\"swap\",\"weight\":\"45 920\"}],\"variableName\":\"pretendardFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layout/Providers.tsx");
